import { Tabs } from "antd";
import React from "react";
import { useSearchParams } from "react-router-dom";
import TabPass from "./tab_pass";
import TabWarn from "./tab_warn";
import TabDeny from "./tab_deny";
import { useEffort } from "hook/draft/effort/useEffort";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const ScoreTabs = () => {
  // -------------------------- VAR -----------------------------
  const { pass, warn, deny } = useEffort();
  const [searchParams, setSearchParams] = useSearchParams();
  const viewOpenScore = searchParams.get("viewOpenScore") || "false";
  const tab = searchParams.get("tab") || "pass";

  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  const handleChangeTab = (key) => {
    const object = { viewOpenScore, page: 1, tab: key };
    setSearchParams(object);
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const items = [
    {
      label: "Được duyệt" + ` (${pass})`,
      key: "pass",
      children: <TabPass />,
    },
    {
      label: "Cảnh báo" + ` (${warn})`,
      key: "warn",
      children: <TabWarn />,
    },
    {
      label: "Từ chối" + ` (${deny})`,
      key: "deny",
      children: <TabDeny />,
    },
  ];
  // -------------------------- MAIN ----------------------------
  return <Tabs activeKey={tab} onChange={handleChangeTab} items={items} />;
};
export default ScoreTabs;
